module.exports = __webpack_public_path__ + "img/icon_star_rate_inactive.456f1d63.svg";